import { Route, Routes } from "react-router";
import Dashboard from "../Admin/Dashboard";
import ProviderDetail from "../Admin/ProviderDetail";
import ProviderList from "../Admin/ProviderList";
import UserList from "../Admin/UserList";
import UserDetail from "../Admin/UserDetail";
import SpecializedServiceList from "../Admin/SpecializedServiceList";
import SubServices from "../Admin/SubServices";
import AppointmentList from "../Admin/AppointmentList";
import AppointmentDetail from "../Admin/AppointmentDetail";
import CreateSubServices from "../Admin/CreateSubServices";
import EditSubService from "../Admin/EditSubService";
import TransactionList from "../Admin/TransactionList";
import CreateSpecializedService from "../Admin/CreateSpecializedService";
import PrivacyPolicy from "../Admin/PrivacyPolicy";
import TermsAndConditions from "../Admin/TermsAndConditions";
import Faqs from "../Admin/Faqs";
import TaxForm from "../Admin/TaxForm";
import CheckrLogs from "../Admin/CheckrLogs";

const AdminRouter = () => {
    return (
         <Routes>
             <Route path="*" element={<Dashboard />} />
             <Route path="/admin/dashboard" element={<Dashboard />} />
             <Route path="/admin/providers" element={<ProviderList />} />
             <Route path="/admin/provider/:id" element={<ProviderDetail />} />
             <Route path="/admin/users" element={<UserList />} />
             <Route path="/admin/user/:id" element={<UserDetail />} />
             <Route path="/admin/specialized_services" element={<SpecializedServiceList />} />
             <Route path="/admin/specialized_services/create" element={<CreateSpecializedService />} />
             <Route path="/admin/specialized_services/sub_services/create" element={<CreateSubServices />} />
             <Route path="/admin/specialized_services/:id" element={<SubServices />} />
             <Route path="/admin/specialized_services/sub_services/:id" element={<EditSubService />} />
             <Route path="/admin/appointment" element={<AppointmentList />} />
             <Route path="/admin/appointment/:id" element={<AppointmentDetail />} />
             <Route path="/admin/transactions" element={<TransactionList />} />
             <Route path="/admin/privacy_policy" element={<PrivacyPolicy />} />
             <Route path="/admin/terms_and_conditions" element={<TermsAndConditions />} />
             <Route path="/admin/faqs" element={<Faqs />} />
             <Route path="/admin/tax_form" element={<TaxForm />} />
             <Route path="/admin/checkr_logs" element={<CheckrLogs />} />
         </Routes>
     );
 }
 
 export default AdminRouter
